import { Routes } from '@angular/router';

/**
 * Section routes rendered inside the Project workspace shell (project-module-view).
 * Each section is tagged with a lifecycle `phase` (pre | during | post); the phase
 * stepper in the shell uses this to filter the sidebar to one phase at a time.
 */
export const projectModuleRoutes: Routes = [
  { path: '', redirectTo: 'overview', pathMatch: 'full', data: { isNotAMenuItem: true } },
  {
    path: 'overview',
    loadComponent: () =>
      import('./sections/overview/project-overview').then((m) => m.ProjectOverview),
    data: { name: 'Overview', icon: 'dashboard', iconType: 'MAT', phase: 'pre' },
  },
   {
    path: 'finance',
    loadComponent: () => import('./sections/finance/project-finance').then((m) => m.ProjectFinance),
    // Finance spans pre + during: funding/budget are set up pre-project, and
    // expenditures are recorded through implementation.
    data: { name: 'Finance', icon: 'payments', iconType: 'MAT', phase: ['pre', 'during'] },
  },
  {
    path: 'structure',
    loadComponent: () =>
      import('./sections/structure/project-structure').then((m) => m.ProjectStructure),
    data: { name: 'Structure', icon: 'account_tree', iconType: 'MAT', phase: 'pre' },
  },
  {
    path: 'team-links',
    loadComponent: () =>
      import('./sections/team-links/project-team-links').then((m) => m.ProjectTeamLinks),
    data: { name: 'Team', icon: 'groups', iconType: 'MAT', phase: 'pre' },
  },
  {
    path: 'implementation',
    loadComponent: () =>
      import('./sections/implementation/project-implementation').then(
        (m) => m.ProjectImplementation,
      ),
    data: { name: 'Implementation', icon: 'engineering', iconType: 'MAT', phase: 'during' },
  },
  {
    path: 'me',
    loadComponent: () => import('./sections/me/project-me').then((m) => m.ProjectMe),
    data: { name: 'M&E', icon: 'analytics', iconType: 'MAT', phase: 'during' },
  },
  {
    path: 'reports',
    loadComponent: () => import('./sections/reports/project-reports').then((m) => m.ProjectReports),
    data: { name: 'Reports', icon: 'summarize', iconType: 'MAT', phase: 'during' },
  },
  {
    path: 'risks-issues',
    loadComponent: () =>
      import('./sections/risks-issues/project-risks-issues').then((m) => m.ProjectRisksIssues),
    data: { name: 'Risks & Issues', icon: 'warning', iconType: 'MAT', phase: 'during' },
  },
  {
    path: 'impact',
    loadComponent: () => import('./sections/impact/project-impact').then((m) => m.ProjectImpact),
    data: { name: 'Impact', icon: 'insights', iconType: 'MAT', phase: 'post' },
  },
  {
    path: 'documents',
    loadComponent: () =>
      import('./sections/documents/project-documents').then((m) => m.ProjectDocuments),
    data: { name: 'Documents', icon: 'folder', iconType: 'MAT', phase: 'post' },
  },
];
